// extracted by mini-css-extract-plugin
module.exports = {"componentsFAQs":"styles_componentsFAQs__3Rc3f","service":"styles_service__1sQgV"};